module.exports = __webpack_public_path__ + "static/img/openvip_VIP.c27ddef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img2/openvip_VIP.png
// module id = 86SX
// module chunks = 1